const location = window.location.hostname
export const IS_DEV_ENV = ['localhost', "staging.riversidemillwork.app", "dev.riversidemillwork.app"].includes(location)
export const NODE_ENV = process.env.NODE_ENV;
export const REACT_APP_API_HOST = process.env.REACT_APP_API_HOST;
export const REACT_APP_MAXPERPAGE = process.env.REACT_APP_MAXPERPAGE;
export const REACT_APP_S3_LINK = process.env.REACT_APP_S3_LINK;
export const PORT = process.env.PORT;
export const REACT_APP_APP_HOSTNAME_2 = process.env.REACT_APP_APP_HOSTNAME_2;
export const REACT_APP_S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
export const REACT_APP_THEME_COLOR = process.env.REACT_APP_THEME_COLOR;